import React from 'react';

import env from '@repo/env';
import IconHelp from '@repo/ui-icons/IconHelp';
import { Popover } from '@repo/ui-kit/components/core/Popover';
import { H6, H5, P4 } from '@repo/ui-kit/components/core/Typography';

import { NavigationMenuButton } from '../NavigationMenuButton';

import { affiliatesSection, helpSection, legalSection } from './config';
import { SupportPopoverSection } from './styles';

export const SupportPopover: React.FC = () => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <NavigationMenuButton>
          <IconHelp color="var(--color-text-secondary)" size={16} />

          <H6 as="span" color="secondary">
            Support
          </H6>
        </NavigationMenuButton>
      </Popover.Trigger>
      <Popover.Content>
        {[helpSection, legalSection, affiliatesSection].map(
          (sectionItems, idx) => (
            <SupportPopoverSection key={idx}>
              {sectionItems.map((item) => (
                <NavigationMenuButton
                  key={item.href}
                  href={item.href}
                  openInNewTab={item.openInNewTab}
                >
                  <H5 as="span" color="secondary">
                    {item.label}
                  </H5>
                </NavigationMenuButton>
              ))}
            </SupportPopoverSection>
          )
        )}
        {env.version && (
          <SupportPopoverSection>
            <P4 color="secondary" textAlign="right">
              Version: {env.version}
            </P4>
          </SupportPopoverSection>
        )}
      </Popover.Content>
    </Popover.Root>
  );
};
